const ZIP_CONST = 5;
export default class Validator {
  checkForErrors(errors, special) {
    const entries = Object.entries(errors);
    for (const [key, value] of entries) {
      if (value !== "" && key !== special) {
        return false;
      }
    }
    return true;
  }

  inputIsEmpty(value) {
    if (!value) {
      return true;
    }
    return false;
  }
  
  inputIsEqualTo(input, value) {
    if (input === value) {
      return true;
    }
    return false;
  }
  
  inputIsGreaterThan(input, value) {
    if (input.length > value) {
      return true;
    }
    return false;
  }
  
  allCheckboxesInGroupUnchecked(values) {
    for (var c in values) {
      if (values[c].is_checked) {
        return false;
      }
    }
    return true;
  }
  
  constrainZip(value) {
    return value.substr(0, ZIP_CONST);
  }
}
